import { rootEventBus, EnumRootEventBus } from "../../../managers/RootEventBus";
import { Coord } from "../../../types/Interface";
import addInteractivity from "../../../utils/addInteractivity";
import { CustomCursorType } from "../CustomCursor/CustomCursor";
import CheckboxRenderer from "./CheckboxRenderer";


export default class Checkbox {
  private CheckboxRenderer!: CheckboxRenderer;
  private isChecked: boolean = false;
  private checkBoxLabel: string;
  private handleFunc: (label: string, v: boolean) => void;

  constructor(coord: Coord, label: string, color: number, useCustomLayer = false, handleFunc = (label: string, v: boolean) => { }) {
    this.CheckboxRenderer = new CheckboxRenderer(color, label, useCustomLayer);
    Object.assign(this.CheckboxRenderer, coord);
    this.handleFunc = handleFunc;
    this.addInteractivity();

    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setVisible(true));
  }
  addToCon = (con: any) => con.addChild(this.CheckboxRenderer);
  setScale = (v: number) => this.CheckboxRenderer.con.scale.set(v);
  private setVisible = (v: boolean) => this.CheckboxRenderer.visible = v;
  private addInteractivity() {
    const handleUpFunc = () => this.handleCheckbox();
    addInteractivity(this.CheckboxRenderer, { handleUpFunc }, CustomCursorType.pointer, undefined, true);
  }
  private handleCheckbox() {
    this.isChecked = !this.isChecked;
    this.handleFunc(this.checkBoxLabel, this.isChecked);
    this.CheckboxRenderer.drawCheckbox(this.isChecked);
  }
  getIsChecked() {
    return {
      label: this.checkBoxLabel,
      isChecked: this.isChecked
    }
  };
  public setChecked(v: boolean) {
    this.isChecked = v;
    this.CheckboxRenderer.drawCheckbox(this.isChecked);
  }
}